import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Text from '../Field/Text';
import SelectField from './SelectField';

function AddressFormSection({
  nations,
  municipalities,
  values,
}) {
  return (
    <>
      <SelectField
        placeholder="Nazione"
        label="Nazione"
        name="indirizzo.nazione"
        component="select"
        options={nations}
        isLoading={!nations.length}
      />
      {values?.indirizzo?.nazione === 'IT' ? (
        <SelectField
          name="indirizzo.citta"
          component="select"
          placeholder="Città"
          label="Città"
          options={municipalities}
        />
      ) : (
        <StyledTextField
          name="indirizzo.cittaNome"
          component="input"
          placeholder="Città"
          label="Città"
        />
      )}
      <StyledTextField
        name="indirizzo.indirizzo"
        component="input"
        placeholder="Indirizzo"
        label="Indirizzo"
      />
      <StyledTextField
        name="indirizzo.cap"
        component="input"
        placeholder="Cap"
        label="CAP"
      />
    </>
  );
}

AddressFormSection.propTypes = {
  nations: PropTypes.array.isRequired,
  municipalities: PropTypes.array.isRequired,
  values: PropTypes.object.isRequired,
};

export default AddressFormSection;

const StyledTextField = styled(Text)`
  margin-bottom: 18px;
  flex-grow: 1;
`;
